import styled from "styled-components";
import theme from "../../../../theme";
import { Col, Row } from "antd";

export const CaseStudySection = styled.div`
  background-color: ${(props) => props.color || theme.white};
  margin: 0 0 96px;
  padding: 96px 0;

  @media (max-width: 426px) {
    margin: 0 0 72px;
    padding: 72px 0;
  }

  .slick-prev,
  .slick-next {
    margin-top: 0 !important;
    bottom: 20px;
    top: auto !important;
    width: auto !important;
    text-align: left;
    &:before {
      color: ${theme.white};
      position: absolute;
      font-size: 20px;
    }
  }
  .slick-prev {
    left: 0 !important;
    z-index: 999;
  }
  .slick-next {
    right: auto;
    left: 35px;
  }
  ul.slick-dots.slick-dots-bottom {
    display: none !important;
  }

  @media (max-width: 768px) {
    .slick-prev,
    .slick-next {
      bottom: -30px;
    }
  }
`;
export const Title = styled.p`
  font-family: "Inter", sans-serif;
  max-width: 800px;
  font-style: normal;
  font-size: 60px;
  line-height: 72px;
  color: ${theme.black};
  margin-bottom: 48px;

  @media (max-width: 768px) {
    font-size: 58px;
    line-height: 85px;
  }
  @media (max-width: 480px) {
    font-weight: 400;
    font-size: 32px;
    line-height: 42px;
  }
  @media (max-width: 380px) {
    font-size: 28px;
    line-height: 40px;
  }
`;
export const RowContainer = styled(Row)`
  display: flex !important;
`;

export const ColContainer = styled(Col)`
  color: white;
  margin: auto 0;

  h2 {
    font-family: "Inter", sans-serif;
    font-weight: 400;
    font-size: 36px;
    line-height: 30px;
    color: #ffffff;
    margin-bottom: 20px;

    @media (max-width: 480px) {
      font-size: 28px;
      line-height: 40px;
    }
  }
  p {
    font-family: "Inter", sans-serif;
    font-size: 20px;
    line-height: 30px;
    color: #ffffff;
    margin-bottom: 10px;
  }

  h4 {
    font-family: "Inter", sans-serif;
    font-size: 20px;
    line-height: 30px;
    color: #ffffff;
    margin-bottom: 10px;
    margin-top: 30px;
  }

  img {
    width: 150px;
  }
`;
